<template>
  <div>
    <v-dialog v-model="isOpen" lazy persistent max-width="1100">
      <v-card class="RealizationModal">
        <v-card-title class="headline">Szczegóły karnetu</v-card-title>
        <v-card-text>
          <v-container class="pt-0 pb-0" grid-list-md>
            <div class="row">
              <div class="col-12 col-xl-6" style="border-right: solid 2px lightgrey">
                <table class="table table-hover table-sm">
                  <tbody>
                  <tr>
                    <td class="font-weight-bold">Nr karnetu</td>
                    <td>{{ticketDetails.ticket_number}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Nr faktury/paragonu</td>
                    <td>{{ticketDetails.invoice_number}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Imię i nazwisko</td>
                    <td>{{ticketDetails.ticket_person}}</td>
                  </tr>
<!--                  <tr>-->
<!--                    <td class="font-weight-bold">Wykorzystano</td>-->
<!--                    <td>{{ticketDetails.column_used}}</td>-->
<!--                  </tr>-->
                  <tr>
                    <td class="font-weight-bold">Status</td>
                    <td><span>{{ticketDetails.status | convertStatusToName}}</span></td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Zablokowany</td>
                    <td>{{ticketDetails.locked | convertLockedToName}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Data wydania</td>
                    <td>{{moment(ticketDetails.created).format('DD-MM-YYYY')}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Data ważności</td>
                    <td>{{moment(ticketDetails.expiration_date).format('DD-MM-YYYY')}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Ostatnia aktualizacja</td>
                    <td>{{moment(ticketDetails.updated_at).format('DD-MM-YYYY HH:mm')}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Wartość</td>
                    <td>PLN {{ticketDetails.price | currency}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Pokaż cenę</td>
                    <td>{{ticketDetails.show_price | boolToStr }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Faktura do karnetu</td>
                    <td>{{ticketDetails.has_invoice | boolToStr }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Dodano przez</td>
                    <td>{{ticketDetails.user ? ticketDetails.user.name : 'Brak'}}
                      {{ticketDetails.user ? ticketDetails.user.surname : 'Brak'}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 col-xl-6">
                <v-data-table
                  :rows-per-page-items="[]"
                  :headers="getRealizationsHeaders"
                  :items="ticketDetails.items"
                  :pagination.sync="paginationData"
                  sort-icon="fa-arrow-down" class="elevation-1 sub-table"
                >
                  <template slot="items" slot-scope="props">

                    <td v-if="props.item.used === 1" class="text-center">{{props.item.number + '. '}}
                      <i class="far fa-check-square"></i>
                    </td>
                    <td v-else-if="props.item.used === 0" class="text-center">{{props.item.number + '. '}}
                      <i class="far fa-square"></i>
                    </td>

                    <td class="text-center">{{moment(props.item.used_at).format('DD-MM-YYYY') | checkUsedItem}}
                    </td>
                    <td class="white-space-nowrap text-center">{{ props.item.description}}
                    </td>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <section class="col-12 pb-4 pr-4 pl-4" v-if="ticketDetails.internal_note">
          <strong style="font-size: 1rem" class="pl-3">Notatka wewnętrzna</strong>
          <div class="pl-2 pr-2">
            <hr class="mt-1 mb-2">
          </div>
          <span class="pl-5 pr-5">{{ticketDetails.internal_note}}</span>
        </section>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" small flat @click="$router.push({name: 'Tickets'})">
            Zamknij
          </v-btn>
          <v-btn v-if="ticketDetails.status !== 'F' && ticketDetails.locked === 0 && moment(ticketDetails.expiration_date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')" small color="#555474"
                 @click="$router.push({name: 'AddRealizationTicketFromDetails', params: {ticketId: ticketDetails.id}})"
                 flat>
            Dodaj realizację
          </v-btn>
          <v-btn v-if="ticketDetails.status !== 'F'" small color="#555474"
                 @click="$router.push({name: 'EditTicketFromDetails', params: {ticketId: ticketDetails.id}})"
                 flat>
            Edytuj karnet
          </v-btn>
        </v-card-actions>
      </v-card>
      <DeleteModal
        :open="deleteTicket"
        deleteText="Czy na pewno chcesz usunąć Karnet?"
        @close="deleteTicket = false"
        @accept="deleteOneTicket(id); deleteTicket = false"
      ></DeleteModal>
      <DeleteModal
        :open="openDeactivateTicket"
        :show-textarea="true"
        deleteText="Czy na pewno chcesz zakończyć karnet?"
        @close="openDeactivateTicket = false"
        @accept="disableTicket"
      ></DeleteModal>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
  /* eslint-disable no-unused-expressions */

  import {mapGetters, mapActions} from 'vuex';
  import FileSaver from 'file-saver';
  import printJS from 'print-js';
  import DeleteModal from '../Globals/ModalDelete.vue';
  import {getPDF} from '../../services/api.service';


  export default {
    name: 'TicketDetails',
    components: {
      DeleteModal,
    },
    data() {
      return {
        isOpen: true,
        loading: true,
        editTicketDate: false,
        openDeactivateTicket: false,
        ticketDetails: {},
        finishTicketDate: new Date().toISOString()
          .substr(0, 10),
        finishTicketDatePicker: false,
        deleteTicket: false,
        types: ['Hotel', 'SPA', 'Restaurant', 'Full', 'New year party', '2019'],
        paginationData: {
          descending: false,
          page: 1,
          rowsPerPage: 15,
        },
      };
    },
    mounted() {
      this.fetchTicketDetails(this.$route.params.ticketId)
        .then((response) => {
          this.ticketDetails = response;
          this.loading = false;
        });
    },
    watch: {
      $route(from) {
        if (from.name === 'TicketDetails') {
          this.loading = true;
          this.fetchTicketDetails(this.$route.params.ticketId)
            .then((response) => {
              this.ticketDetails = response;
              this.loading = false;
            });
        }
      },
    },
    computed: {
      ...mapGetters('TicketStore', ['getMainTableHeaders', 'getRealizationsHeaders']),
    },
    methods: {
      ...mapActions('TicketStore', ['fetchTicketDetails', 'removeTicket', 'turnOffTicket', 'downloadPDF']),
      refreshTicketDetails() {
        this.loading = true;
        this.fetchTicketDetails(this.$route.params.ticketId)
          .then((response) => {
            this.ticketDetails = response;
            this.loading = false;
          });
      },
      async exportPDF(id, number, type) {
        const response = await getPDF(`/ticket/realization/pdf/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        FileSaver.saveAs(blob, `${number} - ${type} - ${this.moment(new Date())
          .format('DD-MM-YYYY')} - export`);
      },
      disableTicket(formData) {
        this.openDeactivateTicket = false;
        this.turnOffTicket({
          id: this.$route.params.ticketId,
          formData,
        })
          .then(() => {
            this.refreshTicketDetails(this.$route.params.ticketId);
          });
      },
      deleteOneTicket(id) {
        this.removeTicket(id)
          .then(() => {
            this.$emit('close');
          });
      },
      async printPDF(id) {
        const response = await getPDF(`/pdf/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        printJS(URL.createObjectURL(blob));
      },
      showPricesSum(data) {
        if (data && data.length > 1) {
          return data
            .map(item => item.price)
            .reduce((previousVal, currentVal) => parseFloat(previousVal) + parseFloat(currentVal))
            .toFixed(2);
        }
        return parseFloat(data
          .map(item => item.price), 2)
          .toFixed(2);
      },
    },
    filters: {
      convertStatusToName(status) {
        switch (status) {
          case 'F':
            return 'Zakończone';
          case 'N':
            return 'Nowe';
          case 'I':
            return 'W realizacji';
          default:
            return 'Nieznany status';
        }
      },
      convertLockedToName(locked) {
        switch (locked) {
          case 0:
            return 'Nie';
          case 1:
            return 'Tak';
          default:
            return 'Nieznany';
        }
      },
      currency(number) {
        return parseFloat(number)
          .toFixed(2);
      },
      boolToStr(value) {
        if (value) return 'Tak';
        return 'Nie';
      },
      checkUsedItem(value) {
        if (value === 'Invalid Date') return 'Nie ustawiono';
        return value;
      },
    },
  };
</script>

<style scoped>

</style>
